import { ReactNode } from 'react';

import { useLocation } from 'react-router-dom';

import PageTransition from '@/components/ui/page-transition';

interface PageContentTransitionProps {
  children: ReactNode;
  /**
   * Custom transition key. If not provided, uses the current pathname.
   * Use this when you want to control when transitions occur (e.g., only on certain path segments)
   */
  transitionKey?: string;
  className?: string;
}

/**
 * Wrapper component that applies page transitions to content.
 * Use this in layouts or pages where you want content to animate on route changes,
 * while keeping navigation/sidebar elements static.
 */
export default function PageContentTransition({
  children,
  transitionKey,
  className,
}: PageContentTransitionProps) {
  const location = useLocation();
  const key = transitionKey ?? location.pathname;

  return (
    <PageTransition key={key} className={className}>
      {children}
    </PageTransition>
  );
}
